// extracted by mini-css-extract-plugin
module.exports = {"wave2DetailE":"E_wave2DetailE__JEtQM","wave-fast-ani":"E_wave-fast-ani__ddh_U","wave-op-ani":"E_wave-op-ani__ydjQt"};